import { Injectable } from '@angular/core';
import { EnvService } from '../env-service/env-service';
import { ConfigService } from '../config-service/config-service';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { UtilityService } from '../utility.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

@Injectable( { providedIn: 'root' })
export class AuthService {
    private TOKEN_KEY = 'oauthToken';
    private TOKEN_KEY_JWT = 'e3jwt';
    private useOIDC = false;

    foceExpire = false;
    fromieu: boolean;

    constructor(
        private envService: EnvService,
        private configService: ConfigService,
        private utilityService: UtilityService,
        private translateService: TranslateService,
        private oauthService: OAuthService
        ) {
        // inizializzazioe di un token valido per saltare l'accesso
        // const token = {
        // tslint:disable-next-line:max-line-length
        //     access_token: 'eyJraWQiOiJyc2ExIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJ1cm46b2lkOjEuMy42LjEuNC4xLjI1MTc4LjEuMi4xNSIsImF6cCI6ImFwcGRvY2VudGkiLCJmaXNjYWxDb2RlIjoiRE5PRE5JOTBUMTJMNzgxSiIsImlzcyI6Imh0dHBzOlwvXC91bml2ci5vcGVuaWQuY2luZWNhLml0XC9vYXV0aDJcLyIsImV4cCI6MTU1NjY5NzA0OSwiaWF0IjoxNTU0MTA1MDQ5LCJ0ZW5hbnQiOiJVTklWUiIsImp0aSI6ImY1OTkwOWFjLTRkMjctNGU1OS1iMjAxLWYyNTljZDIyMWZhMiJ9.oiV2KGqxEXC3VMzuRQM0zMJVryGTKZbxtsCopctkbvvondw12w5m2C1dY2cKd_VfmXx71LgFLoyGir9U1FBamwhxGSlCbPmXuyvrMmJqg6mI6ou2IjNmS2p-5NHEu_fuC6AH4k_aZ_0aYnK6bA42snz8LxHHE4QC2rdrjhZE6yI',
        //     expires_in: '2591999',
        //     scope: 'address phone openid email profile offline_access',
        //     token_type: 'Bearer'
        // };
        // this.setOAuthToken(token);
        // this.setOAuthToken(null);
    }

    public async init (): Promise<boolean> {

      this.useOIDC = this.envService.OIDC_ISSUER ? true : false;

      const idpUrl = this.envService.OAUTH_AUTHORIZE_URL.replace('authorize', '');

      const oAuthConfiguration: AuthConfig = {
          issuer: idpUrl,
          redirectUri: this.envService.PWA_URL,
          postLogoutRedirectUri: this.envService.PWA_URL,
          clientId: this.envService.OAUTH_CLIENT_ID,
          requireHttps: false
      }
      const oidcConfiguration: AuthConfig = {
          issuer: this.envService.OIDC_ISSUER,
          redirectUri: this.envService.PWA_URL,
          postLogoutRedirectUri: this.envService.PWA_URL,
          clientId: this.envService.OIDC_CLIENT_ID,
          responseType: this.envService.OIDC_RESPTYPE,
          scope: this.envService.OIDC_SCOPE,
          dummyClientSecret: this.envService.OIDC_SECRET,
          requireHttps: false,
          skipIssuerCheck: true,
          strictDiscoveryDocumentValidation: false
      }

      this.oauthService.configure(this.useOIDC ? oidcConfiguration : oAuthConfiguration);
      this.oauthService.setupAutomaticSilentRefresh();
      await this.oauthService.loadDiscoveryDocument();
      return this.oauthService.tryLogin();
    }
    public login () {
      this.oauthService.initLoginFlow();
    }
    public logout () {
      this.oauthService.logOut(true);
    }

    /**
     * ritorna l'access token per l'accesso alle API di backend
     */
    getAccessToken(): string {
      const authToken = this.getAuthToken();
      return authToken ? authToken.toString() : undefined;
    }

    /**
     * restituisce l'id del token per la logout dal outh
     */
    getTokenId(): string {
        const token = localStorage.getItem(this.TOKEN_KEY);
        return token ? JSON.parse(token).id_token : undefined;
    }

    isAuthorized(): boolean {
        console.log('this.getAuthToken()', this.getAuthToken());
        console.log('localUrl', 'http://localhost:8100/assets/html/callfromext.html#' + this.getAuthToken());
        console.log('this.isAuthExpired()', this.isAuthExpired());
        return !!this.getAuthToken() && !this.isAuthExpired();
    }

    /**
     * return true se l'autenticazione (l'access token) è scaduto
     */
    isAuthExpired(): boolean {
      const accessToken = this.getAccessToken();
      if (accessToken) {
        // console.log('1', accessToken);
        return this.isTokenExpired(accessToken);
      } else {
        return false;
      }
    }

    setOAuthToken(token: Object) {
        localStorage.setItem(this.TOKEN_KEY, JSON.stringify(token));
    }

    setJwtToken(token: string) {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        console.log('decoded token', decodedToken);
        if (decodedToken.fiscalCode === '') {
            const errMssage = this.translateService.instant('auth.service.msg.invalidcf');
            throw errMssage;
        } else {
            const locToken = this.genE3TokenHolder(token, decodedToken);
            localStorage.setItem(this.TOKEN_KEY_JWT, JSON.stringify(locToken));
        }
    }

    /**
     * ritorna l'oggetto  con cui ha risposto il sistema di autenticazione
     */
    getAuthToken(): Object {
      let token = localStorage.getItem(this.TOKEN_KEY);
      if (token) { return JSON.parse(token).access_token; }

      token = localStorage.getItem(this.TOKEN_KEY_JWT);
      if (token) { return JSON.parse(token).access_token; }
      
      // è necessario inviare l'access token anche nel caso in cui si utilizzi l'oidc 
      // per poter utilizzare lato bff la user_info dell'idp
      // if (this.useOIDC) { return this.oauthService.getIdToken(); }
      token = this.oauthService.getAccessToken(); 
      return token;
    }

    removeOAuthToken() {
        localStorage.removeItem(this.TOKEN_KEY);
    }

    removeJwtToken() {
        localStorage.removeItem(this.TOKEN_KEY_JWT);
    }


    /****
     * metodi di help per token jwt
     *
     * cfr. https://github.com/auth0/angular2-jwt/blob/435b8fc48415e57da40a788777a53ba37c906620/angular2-jwt.ts
     */
    private urlBase64Decode(str: string): string {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: { break; }
            case 2: { output += '=='; break; }
            case 3: { output += '='; break; }
            default: {
                throw new Error ('Illegal base64url string!');
            }
        }
        return this.b64DecodeUnicode(output);
    }

    // credits for decoder goes to https://github.com/atk
    private b64decode(str: string): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';

        str = String(str).replace(/=+$/, '');

        if (str.length % 4 === 1) {
            throw new Error('\'atob\' failed: The string to be decoded is not correctly encoded.');
        }

        for (
            // initialize result and counters
            let bc = 0, bs: any, buffer: any, idx = 0;
            // get next character
            buffer = str.charAt(idx++);
            // character found in table? initialize bit storage and add its ascii value;
            // tslint:disable-next-line:no-bitwise
            ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                // tslint:disable-next-line:no-bitwise
                bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
        ) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }

    // https://developer.mozilla.org/en/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
    private b64DecodeUnicode(str: any) {
        return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    private decodeToken(token: string): any {
        const parts = token.split('.');

        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }

        const decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token');
        }

        return JSON.parse(decoded);
    }

    private getTokenExpirationDate(token: string): Date {
        let decoded: any;
        decoded = this.decodeToken(token);

        // console.log('2', decoded);
        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }

        const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
        date.setUTCSeconds(decoded.exp);

        // console.log('2.3', date);
        return date;
    }

    private getTokenIssuedAtDate(token: string): Date {
        let decoded: any;
        decoded = this.decodeToken(token);

        // console.log('2', decoded);
        if (!decoded.hasOwnProperty('iat')) {
            return null;
        }

        const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
        date.setUTCSeconds(decoded.iat);

        // console.log('2.3', date);
        return date;
    }

    private elapsedEnoughSinceIssue(token: string): boolean {
        const timeToWaitToRefresh = this.configService.getConfigurazione(ChiaveConfig.JWT_TOKEN_REFRESH_TIME);
        const date = this.getTokenIssuedAtDate(token);
        // console.log('iat', date);
        // console.log('new Date()', new Date());
        return (new Date().valueOf() > (date.valueOf() + (timeToWaitToRefresh * 1000)));
    }

    private isTokenExpired(token: string, offsetSeconds?: number): boolean {
        const date = this.getTokenExpirationDate(token);
        // console.log('3', date);
        offsetSeconds = offsetSeconds || 0;

        if (date == null) {
            return false;
        }

        // Token expired?
        return this.foceExpire || !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
    }

    genE3TokenHolder(token: Object, decodedToken: any) {
        console.log('genE3TokenHolder');
        const jsonObject = {};
        jsonObject['access_token'] = token;
        jsonObject['exp'] = decodedToken.exp;
        console.log('jsonObject', jsonObject);
        return jsonObject;
    }

    getE3CallbackUrl() {
        const decoded = this.decodeToken(this.getAccessToken());
        let urlCallback;
        // console.log('decoded.urlCallback', decoded.urlCallback)
        if (decoded.urlCallback) {
            urlCallback = this.b64decode(decoded.urlCallback);
        }
        // console.log('urlCallback', urlCallback);
        return urlCallback;
    }

    getE3Session() {
        const decoded = this.decodeToken(this.getAccessToken());
        return  decoded.jsessionid;
    }

    getAdLogId(): number {
        const decoded = this.decodeToken(this.getAccessToken());
        if (decoded.adLogId) {
            return decoded.adLogId;
        }
        return undefined;
    }

    getLanguage() {
        let lang = 'it';
        const decoded = this.decodeToken(this.getAccessToken());
        if (decoded && decoded.sessioneWebLinguaCod) {
            if ('eng' === decoded.sessioneWebLinguaCod) {
                lang = 'en'
            }
        }
        return lang;
    }
    
    getStuId(): number {
        const decoded = this.decodeToken(this.getAccessToken());
        if (decoded.stuId) {
            return decoded.stuId;
        }
        return undefined;
    }

    // getLogDomPartCod(): number {
    //     const decoded = this.decodeToken(this.getAccessToken());
    //     if (decoded.logDomPartCod) {
    //         return decoded.logDomPartCod;
    //     }
    //     return undefined;
    // }

    getSub(): string {
        const decoded = this.decodeToken(this.getAccessToken());
        if (decoded.sub) {
            return decoded.sub;
        }
        return undefined;
    }

    getFunction() {
        const decoded = this.decodeToken(this.getAccessToken());
        if (decoded.funzione) {
            return decoded.funzione;
        }
        return undefined;
    }

    registryIntegration() {
        return this.getE3CallbackUrl() ? true : false;
    }

    refreshTokenAndSession(requrl: string) {
        console.log('refreshTokenAndSession for ', requrl);
        if (this.elapsedEnoughSinceIssue(this.getAccessToken())) {
            console.log('refreshing token and session');
            this.envService.refreshJWT(this.getAccessToken()).subscribe( newToken => {
                console.log('newToken', newToken);
                this.setJwtToken(newToken);
                this.envService.refreshSessione(this.getE3Session()).subscribe( data => {
                    console.log('data refreshSessione', data);
                    if (this.checkUser(data)) {
                        console.log('utente corrispondente a quello di refresh');
                    } else {
                        console.log('utente NON corrispondente a quello di refresh');
                        this.foceExpire = true;
                        const message = this.translateService.instant('auth.service.msg.forceauthexpired');
                        this.utilityService.presentToast(message);
                    }
                }, (error) => {
                    console.error('Error refreshing e3 session', error);
                });
            }, (error) => {
                console.error('Error refreshing token', error);
            });
        } else {
            console.log('NO need to refresh token and session');
        }
    }

    private checkUser(data: any): boolean {
        // recupera il sub dal token e lo confronta con lo userId presente nel dato recuperato dal refresh di sessione
        return this.getSub() === data['userId'];
    }

    isFromIEU() {
        return this.readFirstDestFromCookie() !== undefined;
    }

    readFirstDestFromCookie(): string {
        const keyValuePairs = document.cookie.split(/; */);
        for (let i = 0; i < keyValuePairs.length; i++) {
            const name = keyValuePairs[i].substring(0, keyValuePairs[i].indexOf('=')).trim();
            const value = keyValuePairs[i].substring(keyValuePairs[i].indexOf('=') + 1).trim();
            if (name === 'firstieudest') {
              console.log('getting firstieudest', value);
              return value;
            }
          }
          return undefined;
      }
      writeFirstDestCookie(ieudest: string ) {
        document.cookie = 'firstieudest=' + ieudest;
      }
}
